module.exports = __webpack_public_path__ + "static/media/t-2-q-7.9b5c4423.jpg";